var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex w-full flex-row-reverse"},[_c('SelectField',{ref:"changeStatus",staticClass:"w-1/6 pb-0",attrs:{"label":"Change Status To","fixedLabels":true,"options":_vm.statusOptions,"required":true,"selected":_vm.selected},on:{"change":_vm.changeStatus}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }